import React from "react";

import {
    Autocomplete,
    FilterRemoveIcon,
    Heading,
    IconButton,
    Label,
    Pane,
    Paragraph, SearchInput,
    SelectField,
    TextInputField,
    toaster,
    Tooltip
} from "evergreen-ui";
import {useDispatch, useSelector} from "react-redux";
import {
    decadeConstructor,
    operationsSelector,
    selectorStationsForFilters,
    useCreateFilterMutation
} from "../periodValuesFilterApi";
import {
    addFiltersRow,
    deleteRowAction,
    deselectDecadeOperationAction,
    deselectResultOperationAction,
    selectCodeAction,
    selectDatasourceAction,
    selectDatasourceTypeAction,
    selectDecadeOperationAction, selectEntityAction,
    selectOperationAction,
    selectResultOperationAction,
    selectStationAction,
    setDuplicationTypeAction,
    setNewDecadeConstructor,
    setWithoutDaysAction
} from "../constructorSlice";
import {findFirstByName} from "../common/matchMethods";
import DecadeTable from "./DecadeTable";
import FiltersPanel from "../common/FiltersPanel";
import {getDatasourceTypesByStation, saveTemplate} from "./ApiCalls";
import {getDecadeConstructorRights} from "../../Privileges/PrivilegesSelectors";
import CreateDecadeOutputFormDialog from "./CreateOutputFormDialog";
import {defaultConstructor} from "../common/constructorObject";
import OperationsComponent from "../common/OperationsComponent";
import SmartButton from "../common/SmartButton";
import CreateTemplateDialog from "../common/CreateTemplateDialog";
import {createFullStationName, createFullStationNameWithOuterIdx} from "../Constructor.DefaultPage";
import {AutoCompleteConstructor} from "../../BaseConstructor/BaseConstructor";

export default function PeriodsValuesPage({isFullInfo, isEdit}) {
    const dispatch = useDispatch();

    const stations     = useSelector(selectorStationsForFilters);
    const operations   = useSelector(operationsSelector);

    const constructor = useSelector(decadeConstructor);

    const [saveFilter] = useCreateFilterMutation();

    const filters = constructor.filtersRows;
    const decadeOperations = constructor.decadeOperations;
    const tableOperations = constructor.tableOperations;

    const [dsourceTypes, setDsourceTypes] = React.useState([])

    const privileges = useSelector(state => state.login.privileges)
    const rights = getDecadeConstructorRights(privileges)

    const [isShown, setIsShown] = React.useState(false)
    const setDecadeShownCallback = (shown) => setIsShown(shown)

    const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
    const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

    const [idx, setIdx] = React.useState(chooseIdx())

    function chooseIdx() {
        for (let i = 0; i < stations.length; i++) {
            if (stations[i].name === constructor.station.name)
                return stations[i].idx
        }
        return undefined
    }

    React.useEffect(() => {
        if (isFullInfo || isEdit) {
            setDsourceTypes(constructor.station.sourcesTypes)
        }
    })

    function onSelectStation(selectedItem) {
        clearFilter()
        setIdx(
            selectedItem.split("] ")[0]
                .replace("[", "")
        )
        selectedItem = selectedItem.split("] ")[1]
        let res = findFirstByName(stations, selectedItem)

        getDatasourceTypesByStation(res.id).then((result) => {
            setDsourceTypes(JSON.parse(JSON.stringify(result.data)))
            res = {id: res.id, name: res.name, sourcesTypes: result.data}
            dispatch(selectStationAction(res));
        })
    }

    function isCreateTemplateDisabled() {
        return constructor.filtersRows[constructor.filtersRows.length-1].code.id == -1
    }

    function isOutputFormDisabled() {
        return constructor.filtersRows[constructor.filtersRows.length-1].code.id == -1
    }


    function checkAllFieldSet() {
        // if (constructor.decadeOperations.length === 0) {
        //     toaster.danger("Декадные операции не установлены")
        //     return false;
        // }
        if (constructor.tableOperations.length === 0) {
            toaster.danger("Операции для таблицы не установлены")
            return false;
        }


        for (let i = 0; i < constructor.filtersRows.length; i++) {
            if (constructor.filtersRows[i].operation === "") {
                toaster.danger("Операция для фильтра №" + (i+1) + " не установлена")
                return false
            }
        }

        return true
    }

    function clearFilter() {
        dispatch(setNewDecadeConstructor({...defaultConstructor}))
    }

    return (
        <Pane display="block"  marginBottom={10}>
            {
                !isFullInfo ?
                    isEdit ? <></> : <Heading size={600}>Конструктор "Суточных, декадных, месячных значений"</Heading> :
                    <>
                        <Pane display={"flex"} columnGap={20} marginBottom={5}>
                            <Pane marginTop={3}><Label>Тип шаблона: </Label></Pane>
                            <Pane><Paragraph>"Суточные, декадные и месячные значения"</Paragraph></Pane>
                        </Pane>
                        <Pane display={"flex"} columnGap={20} marginBottom={15}>
                            <Pane marginTop={3}><Label>Название шаблона: </Label></Pane>
                            <Pane><Paragraph>"{constructor.name}"</Paragraph></Pane>
                        </Pane>
                    </>

            }

            <Pane marginTop={5}>
                <Pane display="flex">
                    <Pane marginBottom={15}>
                        <Pane marginBottom={5}>
                            Станция
                        </Pane>
                        {AutoCompleteConstructor(
                            onSelectStation,
                            constructor,
                            idx,
                            stations,
                            isFullInfo,
                            createFullStationNameWithOuterIdx,
                            createFullStationName
                        )}
                    </Pane>
                </Pane>
                <Pane>
                    <FiltersPanel
                        constructor={constructor}
                        filters={filters}
                        onAddFilterButton={() => dispatch(addFiltersRow())}
                        isFullInfo={isFullInfo}
                        deleteRowAction={deleteRowAction}
                        datasourceTypes={dsourceTypes}
                        selectDatasourceTypeAction={selectDatasourceTypeAction}
                        selectDatasourceAction={selectDatasourceAction}
                        selectCodeAction={selectCodeAction}
                        selectOperationAction={selectOperationAction}
                        selectEntityAction={selectEntityAction}
                    />
                </Pane>
            </Pane>

            <Pane marginTop={-20} marginBottom={10}>
                <Pane display={"flex"} >
                    <OperationsComponent operations={operations}
                                         disabled={isFullInfo}
                                         columns={['для декадных значений', 'для таблицы']}
                                         columnsOnSelectActions={[selectDecadeOperationAction, selectResultOperationAction]}
                                         columnsOnDeselectActions={[deselectDecadeOperationAction, deselectResultOperationAction]}
                                         selectedOperationsForColumns={[decadeOperations, tableOperations]}
                    />
                </Pane>
            </Pane>

            <Pane display="flex"columnGap={20} alignItems={"top"} marginTop={-5}>
                <Label width={180}>Убрать суточные значения</Label>
                <SelectField
                    disabled={decadeOperations.length === 0 || isFullInfo}
                    value={constructor.withoutDays}
                    onChange={val => dispatch(setWithoutDaysAction(val.target.value === "true"))}
                    width={250}
                >
                    <option value={true}>
                        Да
                    </option>
                    <option value={false} selected>
                        Нет
                    </option>
                </SelectField>
            </Pane>
            <Pane display="flex"columnGap={20} marginTop={-15} alignItems={"top"}>
                <Label width={180}>Дублировать таблицу по</Label>
                <SelectField
                    disabled={filters.length === 1 || isFullInfo}
                    value={!isFullInfo && !isEdit ? constructor.duplicationType : constructor.multiplyDimension ? constructor.duplicationType : "NONE"}
                    onChange={val => {dispatch(setDuplicationTypeAction(val.target.value))}}
                    width={250}
                >
                    <option value="NONE" selected>Нет</option>
                    <option value="DATASOURCE_TYPE">
                        Типу источника
                    </option>
                    <option value="CODE">
                        Типу источника и коду
                    </option>
                </SelectField>
            </Pane>

            {isFullInfo || isEdit ? <></> : <Pane marginTop={-10} marginBottom={10} display={"flex"} columnGap={10}>
                {
                    rights.canSaveTemplate ?
                            <SmartButton
                                disabledTooltip={"Выберите фильтры"}
                                buttonText={"Сохранить шаблон"}
                                isDisabled={isCreateTemplateDisabled()}
                                onClickAction={() => {
                                    if (checkAllFieldSet()) {
                                        setCreateTemplateShown(true)
                                    }
                                }}
                            />
                            : <></>
                }
                {
                    rights.canCreateOutputForm ?
                        <SmartButton
                            disabledTooltip={"Выберите фильтры"}
                            buttonText={"Выгрузить выходную форму"}
                            isDisabled={isOutputFormDisabled()}
                            onClickAction={() => {
                                if (checkAllFieldSet()) {
                                    setIsShown(true);
                                }
                            }}
                        /> : <></>
                }
                <Tooltip content="Сбросить">
                    <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                </Tooltip>

            </Pane>}

            {
                isFullInfo || isEdit  ? <></> :
                    <DecadeTable
                        decadeOperations={decadeOperations}
                        tableOperations={tableOperations}
                    />
            }

            <CreateTemplateDialog isShown={createTemplateShown}
                                  setIsShown={setCreateTemplateShownCallback}
                                  createTemplate={(templateName) => saveTemplate(constructor, saveFilter, templateName)}
            />
            <CreateDecadeOutputFormDialog constructor={constructor} isShown={isShown} setIsShown={setDecadeShownCallback} name={""}/>
        </Pane>
    )
}